import { useEffect } from 'react';
import { gtm } from '@lessonnine/marketing-tracker';

import { isInvalidLearnLang } from 'src/viewLayer/helpers/validateLearnLang';
import { GEO_DATA, LOCALE } from 'src/dataLayer/env';

const useInitGTM = (learnLang: string): void => {
  useEffect(() => {
    if (!isInvalidLearnLang(learnLang)) {
      gtm.init({
        geoData: {
          city: GEO_DATA.city,
          countryAlpha3: GEO_DATA.countryCode3,
          region: GEO_DATA.region
        },
        learnLanguageAlpha3: learnLang,
        locale: LOCALE
      });
    }
  }, [learnLang]);
};

export default useInitGTM;
